export const mapSettingsPlatform = (data) => {
  const response = {
    deliveryRadius: data['RaioEntrega'],
    deliveryMinTime: data['TempoEntregaMinimo'],
    deliveryMaxTime: data['TempoEntregaMaximo'],
    freeDeliveryMaxDistance: data['RaioFreteGratis'],
    freeDeliveryMinValue: data['ValorMinimoPedidoFreteGratis'],
    deliveryType: data['ModeloTaxaId'] || 'default$',
    cookingTimeStatus: data['PossuiCookingTime'] || false,
    cookingTimeValue: data['TempoLimiteCookingTime'] || null,
    automaticLogistic: data['LogisticaAutomatica'] || false,
    logisticalLevel: data['PatamaresEntrega']
      ? data['PatamaresEntrega'].map((level) => {
          return {
            radius: level['Raio'],
            value: level['Valor'],
          };
        })
      : [],
    deliveryPlatform: data['PlataformasEntrega']
      ? data['PlataformasEntrega'].map((platform) => {
          return {
            platform: platform['PlataformaDeliveryId'],
            integrationKey: platform['IdEstabelecimentoPlataforma'],
            callDeliveryman: platform['ChamarEntregador'] || false,
            deliveryTaxCalc: platform['CalcularTaxaEntrega'] || false,
            priority: platform['OrdemPrioridade'],
            security: platform['Seguro'],
            callDeliverymanManually: platform['ChamarEntregadorManual'],
            serviceTax: null,
          };
        })
      : [],
    freeDeliveryStatus:
      !!data['RaioFreteGratis'] || !!data['ValorMinimoPedidoFreteGratis'] || false,
    logisticalLevelUntil: '',
    logisticalLevelValue: '',
    platform: 'default$',
    integrationKey: '',
    deliveryTaxCalc: false,
    callDeliveryman: false,
    security: false,
    callDeliverymanManually: false,
  };

  return response;
};

export const makePayoadPostSettingPlatform = (payload) => {
  let payloadToAdd;

  if (payload.logisticalLevel.length) {
    payloadToAdd = {
      ['PatamaresEntrega']: payload.logisticalLevel
        ? payload.logisticalLevel.map((level) => {
            return {
              Raio: level.radius,
              Valor: level.value,
            };
          })
        : [],
      ['PlataformasEntrega']: [],
    };
  }

  if (payload.deliveryPlatform.length) {
    payloadToAdd = {
      ['PlataformasEntrega']: payload.deliveryPlatform
        ? payload.deliveryPlatform.map((platform) => {
            return {
              PlataformaDeliveryId: platform.platform,
              IdEstabelecimentoPlataforma: platform.integrationKey,
              ChamarEntregador: platform.callDeliveryman,
              CalcularTaxaEntrega: platform.deliveryTaxCalc,
              OrdemPrioridade: platform.priority,
              Seguro: platform.security,
              ChamarEntregadorManual: platform.callDeliverymanManually,
              TaxaServico: null,
            };
          })
        : [],
      ['PatamaresEntrega']: [],
    };
  }

  return {
    ...payloadToAdd,
    ['RaioEntrega']: payload.deliveryRadius,
    ['TempoEntregaMinimo']: payload.deliveryMinTime,
    ['TempoEntregaMaximo']: payload.deliveryMaxTime,
    ['RaioFreteGratis']: payload.freeDeliveryMaxDistance,
    ['ValorMinimoPedidoFreteGratis']: payload.freeDeliveryMinValue,
    ['ModeloTaxaId']: payload.deliveryType === 'default$' ? undefined : payload.deliveryType,
    ['PossuiCookingTime']: payload.cookingTimeStatus,
    ['TempoLimiteCookingTime']: payload.cookingTimeValue || null,
    ['LogisticaAutomatica']: payload.automaticLogistic,
    ['IgnorarModeloIntegracaoDelivery']: !payload.selectedDeliveryTypeAvailable,
  };
};
